import { useEffect, useState } from "react";
import { useAppSelector } from "./reduxHooks";

export default function useFormConstantLabel(label) {
  const siteData = useAppSelector((state) => state.siteData);

  return siteData?.brandingSettings?.form?.[label] || "Flight Deals";
}
